<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class='h100vh-100'>
        <div class='h-toolbarBg'>
          <ejs-toolbar>
            <e-items>
              <e-item v-if='uploadBoolean' prefixIcon='icon hero-icon hero-icon-upload' :tooltipText='$t("DeployManagement.uploadServPackage")' :click='addDialog'></e-item>
              <e-item v-if='batchUploadBoolean' prefixIcon='icon hero-icon hero-icon-batch-upload' :tooltipText='$t("DeployManagement.batchUploadServPackage")' :click='batchUpload'></e-item>
              <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("DeployManagement.delete")' :click='deleteFun'></e-item> 
              <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click='refreshServiceList'></e-item>
            </e-items>
          </ejs-toolbar>
          <div class='h-inputBox'>
            <input class='e-input' :placeholder='$t("DeployManagement.inputPlaceholder_netype")' @keyup.enter='filter' v-model='keyword' maxLength='15' />
          </div>
        </div>
        <!-- <div class='h-ainfoBg'>
          <div class='h-ainfo'>
            <span class='icon hero-icon hero-icon-detailcode'></span>
            <span>{{$t('DeployManagement.netypeCount')}}：{{totalCount}}</span>
          </div>
        </div> -->
        <div class='h100-40 noPage'>
          <Table ref="grid"></Table>
        </div>
      </div>
      <CustomDialog ref='upload' :element='upload.element' :styles='upload.styles1'>
        <template v-slot:dialog-content>
          <AddDialog ref='addObj'></AddDialog>
        </template>
      </CustomDialog>
      <CustomDialog ref='bathUpload' :element='upload.element' :styles='upload.styles' >
        <template v-slot:dialog-content>
          <BatchUploadDialog ref='doBatch'/>
        </template>
      </CustomDialog>
      <CustomDialog ref='serverDetailPage' :element='dialog.eleServerDetailPage' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <ServerDetailDialog ref='serverDetail'></ServerDetailDialog>
        </template>
      </CustomDialog>
      <CustomDialog ref='batchDeployImsPage' :element='batchDeployImsDialog.element' :styles='batchDeployImsDialog.styles'>
        <template v-slot:dialog-content>
          <BatchDeployIms ref='batchDeployIms'></BatchDeployIms>
        </template>
      </CustomDialog>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../layouts/BasicLayout';
import AddDialog from '../../../components/deploymentManagement/serverManagement/addDialog';
import BatchDeployIms from '../../../components/deploymentManagement/serverManagement/batchDeployIms';
import BatchUploadDialog from '../../../components/deploymentManagement/serverManagement/batchUploadDialog';
import CustomDialog from '../../../components/common/CustomDialog';
import { EventBus } from '../../../plugins/eventBus';
import { CommandColumn  } from "@syncfusion/ej2-vue-grids";
import detailTemplate from '../../../components/deploymentManagement/deployedInstance/DetailTemplate';
import ServerDetailDialog from '../../../components/deploymentManagement/deployedInstance/ServerDetailDialog';
import Table from '../../../components/deploymentManagement/serverManagement/Table';

export default {
  name: 'ServerManagement',
  provide: {
    grid: [ CommandColumn ]
  },
  components: {
    BasicLayout,
    AddDialog,
    BatchDeployIms,
    BatchUploadDialog,
    CustomDialog,
    ServerDetailDialog,
    Table
  },
  data() {
    return {
      uploadBoolean:JSON.parse(sessionStorage.getItem('authMap')).server_managment.UploadServicePackage,
      batchUploadBoolean:JSON.parse(sessionStorage.getItem('authMap')).server_managment.BatchUploadServicePackage,
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: { show: true, crumb: this.$t('DeployManagement.deployManagement')+'/'+this.$t('DeployManagement.AdapterManagement') },
      editSettings: { allowEditing: true, allowDeleting: true },
      commands: [{ type: 'Edit', buttonOption: { cssClass: 'e-flat', iconCss: 'e-edit e-icons' } },
        { buttonOption: { cssClass:'e-link', content: 'delete', click: this.onClick } }],
      keyword: '',
      uploadProps: {status:0},
      upload: {
        styles: {
          width: '810px',
          height: '752px',
          model: true,
          visible: false
        },
        styles1: {
          width: '500px',
          height: '300px',
          model: true,
          visible: false
        },
        element: {
          refName: "detailLog",
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Common.confirm') } },
          ],
          title: this.$t('DeployManagement.uploadServPackage')
        },
      },
      batchDeployImsDialog: {
        styles: {
          width: '860px',
          height: '752px',
          model: true,
          visible: false
        },
        element: {
          refName: "batchDeployIms",
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Common.cancel') } },
            { click: this.saveBatchDeployIms, buttonModel: { content: this.$t("Common.confirm"),isPrimary: true}}
          ],
          title: this.$t('DeployManagement.batchDeployIms')
        },
      },
      dialog: {
        eleServerDetailPage: {
          target: this.$refs.serverDetail,
          refName: 'serverDetail',
          buttonGroup: [
            {
              click: this.closeServerDetailPage,
              buttonModel: { content: this.$t('SubscriberIms.cancel') }
            }
          ],
          title: this.$t('DeployManagement.detail'),
          isClose: true
        },
        styles: {
          width: '55%',
          height: '80%',
          visible: false,
          model: true
        }
      },
      neMap: {
        0: this.$t('System.neOAM'),
        3: this.$t('Topo.neMME'),
        4: this.$t('Topo.neHSS'),
        5: this.$t('Topo.nePGW'),
        6: this.$t('Topo.neSGW'),
        7: this.$t('Topo.nePCRF'),
        8: this.$t('Topo.neTCF'),
        9: this.$t('Topo.neTMF'),
        10: this.$t('Topo.nePDTGW'),
        11: this.$t('Topo.neDBS'),
        12: this.$t('Topo.neMC_CMS'),
        13: this.$t('Topo.neMC_CF'),
        14: this.$t('Topo.neMC_GMS'),
        15: this.$t('Topo.neMC_IDMS'),
        16: this.$t('Topo.neMC_PF'),
        17: this.$t('Topo.neBM_SC'),
        18: this.$t('Topo.neMBMS_GW'),
        19: this.$t('Topo.neFRS'),
        20: this.$t('Topo.neMC_TMF'),
        21: this.$t('Topo.nePRES'),
        23: this.$t('Topo.neP_HSS'),
        24: this.$t('Topo.neMC_KMS'),
        27: this.$t('Topo.neMCE'),
        28: this.$t('Topo.nePCDR'),
        31: this.$t('Topo.neDMS'),
        34: this.$t('Topo.neMC_GMS_NODE'),
        100: this.$t('Topo.neCU'),
        101: this.$t('Topo.neDU'),
        102: this.$t('Topo.neCU'),
        103: this.$t('Topo.neDU'),
        10001: this.$t('System.epcOAM'),
        10002: this.$t('System.imsOAM'),
        10003: this.$t('System.mcsOAM'),
        10004: this.$t('System.enodeb'),
        10007: this.$t('System.ibs_b'),
        10010: this.$t('System.ims_hytalk'),
        20001: this.$t('System.mcscl'),
        10009: this.$t('Topo.devgNB')
      },
      neType: {
        0: '基础',
        1: '业务'
      },
      detailTemplate(args) {
        return {
          template: detailTemplate
        };
      },
      timeOut: 30*1000,
      totalCount: 0,
    };
  },
  methods: {
    saveBatchDeployIms() {
        this.$loading.showLoadding(this.$t('NSMF.addInstanceLoading'));
        const url = "/lte/ems/nf/deploy/imsBatch";
        this.$refs.batchDeployIms.getFormData(res=> {
           if (!res) {
         this.$loading.hideLoadding();
         return false;
          }  else{
        let That = this;
        this.$axios.post(url, res,{timeout: 60 * 4 * 1000}).then(response => {
          const result = response.data;
          console.log("result", result);
          if ( response &&response.status === 200 &&response.data.errorCode === "SUCCESS") {
            EventBus.$emit("toast", {type: "success",content: `${this.$t("Common.tips.success")}`});
            That.getServiceList();
          } else if(response && response.data.errorCode === "8602"){//目前不确定失败返回信息，暂定此写法
            this.$loading.hideLoadding();
            EventBus.$emit("toast", {
              type: "warning",
              content: response.data.errorString
            });
            return false;
          }
          else {            
            EventBus.$emit("toast", {
              type: "error",
              content: `${this.$t("Common.tips.failure")}`+' '+response.data.errorString           
            });
          }
          this.$loading.hideLoadding();
          That.$refs.batchDeployImsPage.clear();
          That.$refs.batchDeployImsPage.close();
        }).catch(err =>{
        this.$loading.hideLoadding();
        EventBus.$emit("toast", {
              type: "warning",
              content: `${this.$t("Common.tips.failure")}`
            });
          });
          }
        });
    },
    addDialog() {
      this.uploadProps = {status: 1};
      this.$refs.upload.show();
    },
    batchDeployIms() {
      this.$refs.batchDeployImsPage.show();
      this.$refs.batchDeployIms.neTypeChangeFunc();
    },
    getChildProps(data) {
      this.uploadProps = data;
    },
    randomId() {
      const _temp = 'abcdefghijklmnopqrstuvwxyz';
      let randStr = '';
      for (let i = 0; i <= 8; i++) {
        randStr += _temp[Math.round(Math.random(1) * 26)];
      }
      return randStr;
    },
    batchUpload() {
      this.axios.get('/lte/ems/packageManager/queryExistedPackagesList').then(res => {
        let packageList = res.data?res.data.resultVal:null;
        let packageListStr;
        if (packageList && packageList.length>0) {
          packageListStr = this.$t('DeployManagement.uploadConfirmTip');
          for (let index = 0; index < packageList.length; index++) {
            packageListStr += '<br>'+packageList[index];
          }
          packageListStr += '<br>'+this.$t('DeployManagement.totalServicePkg').replace('{0}', packageList.length);
          this.$layer.confirm({
              styles: {
                width: '400px',
                height: '650px',
              },
              msg: packageListStr,
              btn1: { msg: this.$t('MML.cancel')},
              btn2: {
                msg: this.$t('MML.confirm'),
                func: ()=>{
                  this.doBatchUpload(packageList)
                }
              },
            });
        } else {
          packageListStr = this.$t('DeployManagement.tips_serviceListEmpty');
          this.$layer.warn({
              msg: packageListStr,
              btn1: { msg: this.$t('MML.cancel'), isPrimary: false},
            });
        }

      })

    },
    doBatchUpload(packageList){
      const taskId = this.randomId();
      this.axios.post('/lte/ems/packageManager/batchUploadPackages', {taskId:taskId});
      this.$refs.doBatch.setParam({taskId:taskId,pkgList:packageList});
      this.$refs.bathUpload.show();
    },
    delDialog() {
      const selectedData = this.$refs.grid.$refs.grid.getSelectedRecords();
      if (selectedData == null) {
        return null;
      }
      this.$layer.confirm({
        msg: this.$t('System.delPkgTip'),
        btn1: {
          msg: this.$t('System.cancel'),
        },
        btn2: {
          msg: this.$t('System.confirm'),
          func: ()=>{
            this.delSerPkg();
          }
        },
      });
    },

    deleteFun() {
       const selectedData = this.$refs.grid.$refs.grid.getSelectedRecords();
       if(selectedData.length == 0){
         this.eventEmit('warning',`${this.$t('Common.tips.selectOne')}`);
         return;
       }
      this.$layer.confirm({
        msg: `${this.$t('DeployManagement.deletePkg')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.ok')}`,
          func: () => {
            const url = '/lte/ems/packageManager/deletePackage';
            const obj = {};
            obj.oamTypeCode = selectedData[0].serviceId;
            obj.pkgVersion = selectedData[0].pkgVersion;
            obj.oamTypeCode = selectedData[0].oamTypeCode;
            obj.deliverType = selectedData[0].deliverTypeId;
            this.$loading.showLoadding(this.$t('System.deleteFile'), '');
            this.axios.post(url, obj).then(res => {
              this.$loading.hideLoadding();
              if(res.data.errorCode == 'SUCCESS'){
                EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
              }else{
                EventBus.$emit('toast', {type: 'error', content: res.data.errorString});
              }
              EventBus.$emit('deletePackage',{oamTypeCode : obj.oamTypeCode, deliverType:obj.deliverType});
            });
          }
        }
      });
    },
    getServiceList() {
      this.$refs.grid.init(3);
    },
    refreshServiceList() {
      this.$refs.grid.init(3);
      this.keyword='';
    },
    editDialog() {

    },
    filter() {
      // 前台过滤
      console.log(this.keyword);
      this.$refs.grid.refreshData(this.keyword, ['serviceName']);
    },
    delSerPkg() {
      // const selectedData = this.$refs.grid.getParam();
      const selectedData = this.$refs.grid.$refs.grid.getSelectedRecords();
      const url = '/lte/ems/packageManager/deletePackage';
      const models = [];
      selectedData.forEach(item => {
        const obj = {};
        obj.deliverType = item['deliverType'];
        obj.oamTypeCode = item['serviceId'];
        obj.pkgVersion = item['pkgVersion'];
        models.push(obj);
      });
      this.$loading.showLoadding(this.$t('System.deleteFile'), '');
      this.axios.post(url, models).then(res => {
        this.$loading.hideLoadding();
        if(res.data.errorCode == 0){
          EventBus.$emit('toast', {type: 'success', content: this.$t('Topo.delSuccess')});
        }else{
          EventBus.$emit('toast', {type: 'error', content: res.data.errorString});
        }
      });
    },
    onClick(args) {
      console.log(args);
    },
    dialogHide() {
      if(this.uploadProps.status == 1){
        this.$refs.upload.clear();
        this.$refs.upload.close();
        this.$refs.bathUpload.clear();
        this.$refs.bathUpload.close();
        this.getServiceList();
      }else{
        this.$layer.confirm({
          title: this.$t('System.tip'),
          msg: this.$t('DeployManagement.tips_cancelUpload'),
          btn2: {
            msg: this.$t('System.confirm'),
            func: () => {
              this.$refs.addObj.setCancel(1);
              this.$refs.upload.clear();
              this.$refs.upload.close();
              this.$refs.bathUpload.clear();
              this.$refs.bathUpload.close();
              this.getServiceList();
            }
          },
          btn1: {
            msg: this.$t('System.cancel')
          }
        });
      }
    },
    getParam(){
      return this.$refs.addObj.getParam();
    },

    eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content})
    },
    openServerDetailPage(target) {
      console.log('target=', target);
      this.$refs.serverDetail.setQryParam(target.serviceId, '', target.deliverTypeId);
      this.$refs.serverDetailPage.show();
      this.$refs.serverDetail.initTable(target);
    },
    closeServerDetailPage() {
      this.$refs.serverDetail.stateFlag = undefined;
      this.$refs.serverDetailPage.clear();
      this.$refs.serverDetailPage.close();
      this.getServiceList();
    },
  },
  mounted() {
    // this.getServiceList();
    this.$refs.grid.init(3);
  },
  created() {
    EventBus.$on('openDetailPage', target => {
      this.openServerDetailPage(target);
    });
    EventBus.$on('deleteServer', target => {
      // this.deletelFun(target);
      this.delDialog(target);
    });
    EventBus.$on('setChildProps', target => {
      this.getChildProps(target);
    });
    //更新总数量
    EventBus.$on('initTotalNum', target => {
      this.totalCount = target['totalCount'];
    });
    EventBus.$on('closeDetail', target => {
      this.closeServerDetailPage();
    });
    EventBus.$on('qryProgress', target => {
      console.log("qryProgress param.....", target);
      this.$refs.doBatch.setParam({taskId:target['taskId']});
      this.$refs.bathUpload.show();
      this.$refs.upload.clear();
      this.$refs.upload.close();
    });
  }
  // provide: {
  //   grid: [CommandColumn]
  // }
};
</script>
<style>
.e-dlg-content{
}
</style>

